import {
  FETCH_DISTRICT_REQUEST,
  FETCH_DISTRICT_SUCCESS,
  FETCH_DISTRICT_FAILURE,
  FETCH_DISTRICT_COMPOSITIONS_REQUEST,
  FETCH_DISTRICT_COMPOSITIONS_SUCCESS,
  FETCH_DISTRICT_COMPOSITIONS_FAILURE,
  FETCH_DISTRICT_ROLES_REQUEST,
  FETCH_DISTRICT_ROLES_SUCCESS,
  FETCH_DISTRICT_ROLES_FAILURE,
  FETCH_DISTRICT_FEATURES_REQUEST,
  FETCH_DISTRICT_FEATURES_SUCCESS,
  FETCH_DISTRICT_FEATURES_FAILURE,
  FETCH_DISTRICT_LAYERS_REQUEST,
  FETCH_DISTRICT_LAYERS_SUCCESS,
  FETCH_DISTRICT_LAYERS_FAILURE,
  FETCH_DISTRICT_EXTERNALLAYERS_REQUEST,
  FETCH_DISTRICT_EXTERNALLAYERS_SUCCESS,
  FETCH_DISTRICT_EXTERNALLAYERS_FAILURE,
  FETCH_DISTRICT_STYLES_REQUEST,
  FETCH_DISTRICT_STYLES_SUCCESS,
  FETCH_DISTRICT_STYLES_FAILURE,
  FETCH_DISTRICT_PARCELS_REQUEST,
  FETCH_DISTRICT_PARCELS_SUCCESS,
  FETCH_DISTRICT_PARCELS_FAILURE,
  FETCH_PG_LAYER_DATA_REQUEST,
  FETCH_PG_LAYER_DATA_SUCCESS,
  FETCH_PG_LAYER_DATA_FAILURE,
  FETCH_PGLAYERLIST_REQUEST,
  FETCH_PGLAYERLIST_SUCCESS,
  FETCH_PGLAYERLIST_FAILURE,
  FETCH_UPDATE_STYLE_LIST_REQUEST,
  FETCH_UPDATE_STYLE_LIST_SUCCESS,
  FETCH_UPDATE_STYLE_LIST_FAILURE,
  DELETE_STYLE_REQUEST,
  DELETE_STYLE_SUCCESS,
  DELETE_STYLE_FAILURE,
  ADD_STYLE_REQUEST,
  ADD_STYLE_SUCCESS,
  ADD_STYLE_FAILURE,
  ADD_STYLE_FILE_REQUEST,
  ADD_STYLE_FILE_SUCCESS,
  ADD_STYLE_FILE_FAILURE,
  CHANGE_LAYER_STYLE_REQUEST,
  CHANGE_LAYER_STYLE_SUCCESS,
  CHANGE_LAYER_STYLE_FAILURE,
  PUBLISH_LAYER_REQUEST,
  PUBLISH_LAYER_SUCCESS,
  PUBLISH_LAYER_FAILURE,
  DELETE_LAYER_FAILURE,
  DELETE_LAYER_REQUEST,
  DELETE_LAYER_SUCCESS,
  ADD_EXTERNAL_LAYER_REQUEST,
  ADD_EXTERNAL_LAYER_SUCCESS,
  ADD_EXTERNAL_LAYER_FAILURE,
  DELETE_EXTERNAL_LAYER_REQUEST,
  DELETE_EXTERNAL_LAYER_SUCCESS,
  DELETE_EXTERNAL_LAYER_FAILURE,
  ADD_ROLE_REQUEST,
  ADD_ROLE_SUCCESS,
  ADD_ROLE_FAILURE,
  DELETE_ROLE_REQUEST,
  DELETE_ROLE_SUCCESS,
  DELETE_ROLE_FAILURE,
  ADD_ROLE_LAYER_PERMISSIONS_REQUEST,
  ADD_ROLE_LAYER_PERMISSIONS_SUCCESS,
  ADD_ROLE_LAYER_PERMISSIONS_FAILURE,
  DELETE_ROLE_LAYER_PERMISSIONS_REQUEST,
  DELETE_ROLE_LAYER_PERMISSIONS_SUCCESS,
  DELETE_ROLE_LAYER_PERMISSIONS_FAILURE,
  UPDATE_ROLE_LAYER_PERMISSIONS_REQUEST,
  UPDATE_ROLE_LAYER_PERMISSIONS_SUCCESS,
  UPDATE_ROLE_LAYER_PERMISSIONS_FAILURE,
  UPDATE_ROLE_ATTRS_PERMISSIONS_REQUEST,
  UPDATE_ROLE_ATTRS_PERMISSIONS_SUCCESS,
  UPDATE_ROLE_ATTRS_PERMISSIONS_FAILURE,
  UPDATE_ROLE_FEATURES_SUCCESS,
  UPDATE_ROLE_FEATURES_FAILURE,
  UPDATE_ROLE_FEATURES_REQUEST,
  ADD_COMOPSITION_REQUEST,
  ADD_COMOPSITION_SUCCESS,
  ADD_COMOPSITION_FAILURE,
  DELETE_COMOPSITION_REQUEST,
  DELETE_COMOPSITION_SUCCESS,
  DELETE_COMOPSITION_FAILURE,
  DELETE_GES_LAYER_REQUEST,
  DELETE_GES_LAYER_SUCCESS,
  DELETE_GES_LAYER_FAILURE,
  CREATE_NEW_LAYER_REQUEST,
  CREATE_NEW_LAYER_SUCCESS,
  CREATE_NEW_LAYER_FAILURE,
  SIDEDESCRIPTION_VIEW,
  SIDEDESCRIPTION_VIEW_PROJECT,
  CHOSEN_PARCEL,
  FETCH_GRAVES_REQUEST,
  FETCH_GRAVES_SUCCESS,
  FETCH_GRAVES_FAILURE,
  FETCH_ZARZAD_FAILURE,
  FETCH_ZARZAD_REQUEST,
  FETCH_ZARZAD_SUCCESS,
  FETCH_GRAVEYARD_REQUEST,
  FETCH_GRAVEYARD_SUCCESS,
  FETCH_GRAVEYARD_FAILURE,
  FETCH_SECTORS_REQUEST,
  FETCH_SECTORS_SUCCESS,
  FETCH_SECTORS_FAILURE,
  ADDRESS_POLYGON,
  CHOOSE_GRAVE,
  CHOOSE_GRAVEYARD,
  FETCH_ALL_DISTRICTS_REQUEST,
  FETCH_ALL_DISTRICTS_SUCCESS,
  FETCH_ALL_DISTRICTS_FAILURE,
  FETCH_ALL_ESERVICES_SUCCESS,
  FETCH_ALL_ESERVICES_REQUEST,
  FETCH_ALL_ESERVICES_FAILURE,
  FETCH_ALLDISTRICTSERVICES_REQUEST,
  FETCH_ALLDISTRICTSERVICES_SUCCESS,
  FETCH_ALLDISTRICTSERVICES_FAILURE,
} from '../constants';

const districtInitialState = {
  district: null,
  districts: null,
  eservices: null,
  graveyard: {
    features: null,
  },
  graves: null,
  zarzad: null,
  sectors: [],
  chosenGrave: null,
  chosenGraveyard: null,
  pgLayersMetaData: [],
  isDistrictFetched: false,
  isDistrictFetching: false,
  isAllDistrictFetched: false,
  isAllDistrictFetching: false,
  isServicesFetched: false,
  isServicesFetching: false,
  isZarzadFetched: false,
  isZarzadFetching: false,
  pgLayerDataFetched: false,
  pgLayerDataFetching: false,
  isPgLayerListFetching: false,
  isPgLayerListFetched: true,
  isStyleListUpdating: false,
  isStyleListUpdated: false,
  isDeletingLayer: false,
  isStyleDeleting: false,
  isAddingStyle: false,
  isLayerStyleChanging: false,
  isPublishingLayer: false,
  isAddingExternal: false,
  isDeletingExternal: false,
  isAddingRole: false,
  isDeletingRole: false,
  isAddingRoleLayerPermission: false,
  isDeletingRoleLayerPermission: false,
  isUpdatingRoleLayerPermission: false,
  isUpdatingAttrsLayerPermission: false,
  isUpdatingRoleFeatures: false,
  isAddingComposition: false,
  isDeletingComposition: false,
  isDeletingGSLayer: false,
  isCreatingNewlayer: false,
  sideDescription: {
    view: false,
    data: null,
    invest: false,
    contentType: null,
  },
  chosenParcel: null,
  areGravesFetching: false,
  areGravesFetched: false,
  areCompositionsFetched: false,
  areCompositionsBeingFetched: false,
  areParcelsFetched: false,
  areParcelsBeingFetched: false,
  isGraveyardFetching: false,
  isGraveyardFetched: false,
  isSectorsFetching: false,
  isSectorsFetched: false,
  addressPolygon: null,
  areRolesFetched: false,
  areRolesBeingFetched: false,
  areFeaturesFetched: false,
  areFeaturesBeingFetched: false,
  areLayersFetched: false,
  areLayersBeingFetched: false,
  areExternalLayersFetched: false,
  areExternalLayersBeingFetched: false,
  areStylesFetched: false,
  areStylesBeingFetched: false
};
const fetchDistrictStylesRequest = state => ({
  ...state,
  areStylesBeingFetched: true,
});
const fetchDistrictStylesSuccess = state => ({
  ...state,
  district: state.district
    ? {
      ...state.district,
      styles: [...action.payload],
    }
    : {
      styles: [...action.payload],
    },
  areStylesFetched: true,
  areStylesBeingFetched: false,
});
const fetchDistrictStylesFailure = state => ({
  ...state,
  areStylesFetched: false,
  areStylesBeingFetched: false,
});
const fetchDistrictExternalLayersRequest = state => ({
  ...state,
  areExternalLayersBeingFetched: true,
});
const fetchDistrictExternalLayersSuccess = state => ({
  ...state,
  district: state.district
    ? {
      ...state.district,
      externallayers: [...action.payload],
    }
    : {
      externallayers: [...action.payload],
    },
  areExternalLayersFetched: true,
  areExternalLayersBeingFetched: false,
});
const fetchDistrictExternalLayersFailure = state => ({
  ...state,
  areExternalLayersFetched: false,
  areExternalLayersBeingFetched: false,
});
const fetchDistrictLayersRequest = state => ({
  ...state,
  areLayersBeingFetched: true,
});
const fetchDistrictLayersSuccess = state => ({
  ...state,
  district: state.district
    ? {
      ...state.district,
      layers: [...action.payload],
    }
    : {
      layers: [...action.payload],
    },
  areLayersFetched: true,
  areLayersBeingFetched: false,
});
const fetchDistrictLayersFailure = state => ({
  ...state,
  areLayersFetched: false,
  areLayersBeingFetched: false,
});
const fetchDistrictFeaturesRequest = state => ({
  ...state,
  areFeaturesBeingFetched: true,
});
const fetchDistrictFeaturesSuccess = state => ({
  ...state,
  district: state.district
    ? {
      ...state.district,
      features: [...action.payload],
    }
    : {
      features: [...action.payload],
    },
  areFeaturesFetched: true,
  areFeaturesBeingFetched: false,
});
const fetchDistrictFeaturesFailure = state => ({
  ...state,
  areFeaturesFetched: false,
  areFeaturesBeingFetched: false,
});

const fetchDistrictrolesRequest = state => ({
  ...state,
  areRolesBeingFetched: true,
});
const fetchDistrictrolesSuccess = state => ({
  ...state,
  district: state.district
    ? {
      ...state.district,
      roles: [...action.payload],
    }
    : {
      roles: [...action.payload],
    },
  areRolesFetched: true,
  areRolesBeingFetched: false,
});
const fetchDistrictrolesFailure = state => ({
  ...state,
  areRolesFetched: false,
  areRolesBeingFetched: false,
});
const fetchDistrictCompositionsRequest = state => ({
  ...state,
  areCompositionsBeingFetched: true,
});
const fetchDistrictCompositionsSuccess = (state, action) => ({
  ...state,
  district: state.district
    ? {
      ...state.district,
      compositions: [...action.payload],
    }
    : {
      compositions: [...action.payload],
    },
  areCompositionsBeingFetched: false,
  areCompositionsFetched: true,
});
const fetchDistrictCompositionsFailure = state => ({
  ...state,
  areCompositionsBeingFetched: false,
  areCompositionsFetched: false,
});

const fetchDistrictParcelsRequest = state => ({
  ...state,
  areParcelsBeingFetched: true,
});
const fetchDistrictParcelsSuccess = (state, action) => ({
  ...state,
  district: state.district
    ? {
      ...state.district,
      parcels: [...action.payload],
    }
    : {
      parcels: [...action.payload],
    },
  areParcelsBeingFetched: false,
  areParcelsFetched: true,
});
const fetchDistrictParcelsFailure = state => ({
  ...state,
  areParcelsBeingFetched: false,
  areParcelsFetched: false,
});

const districtRequest = state => ({
  ...state,
  isDistrictFetching: true,
});
const districtSuccess = (state, action) => ({
  ...state,
  isDistrictFetching: false,
  isDistrictFetched: true,
  // district: action.payload
  district: state.district
    ? {
      ...action.payload,
      parcels: state.district.parcels,
    }
    : {
      ...action.payload,
    },
});
const districtFailure = state => ({
  ...state,
  pgLayerDataFetching: false,
  pgLayerDataFetched: false,
});

const districtsRequest = state => ({
  ...state,
  isAllDistrictFetching: true,
});
const districtsSuccess = (state, action) => ({
  ...state,
  isAllDistrictFetching: false,
  isAllDistrictFetched: true,
  districts: action.payload,
});
const districtsFailure = state => ({
  ...state,
  isAllDistrictFetching: false,
  isAllDistrictFetched: false,
});

const sevicesRequest = state => ({
  ...state,
  isServicesFetching: true,
});
const servicesSuccess = (state, action) => ({
  ...state,
  isServicesFetching: false,
  isServicesFetched: true,
  eservices: action.payload,
});
const servicesFailure = state => ({
  ...state,
  isServicesFetching: false,
  isServicesFetched: false,
});

const pgLayerDataRequest = state => ({
  ...state,
  pgLayerDataFetching: true,
});

const pgLayerDataSuccess = (state, action) => {
  const hasLayerData = _.find(
    state.pgLayersMetaData,
    o => Object.keys(o)[0] === Object.keys(action.payload)[0],
  );
  if (!hasLayerData) {
    return { ...state, pgLayersMetaData: [action.payload, ...state.pgLayersMetaData] };
  }
  return state;
};

const pgLayerDataFailure = state => ({
  ...state,
  pgLayerDataFetching: false,
  pgLayerDataFetched: false,
});

const districtServicesRequest = state => ({
  ...state,
  districtServicesFetching: true,
});

const districtServicesSuccess = (state, action) => ({
 ...state,
 districtServicesData: action.payload

});

const districtServicesFailure = state => ({
  ...state,
  districtServicesFetching: false,
  districtServicesFetched: false,
  
});

const pgLayerListRequest = state => ({
  ...state,
  isPgLayerListFetched: true,
});

const pgLayerListSuccess = (state, action) => ({
  ...state,
  district: {
    ...state.district,
    pg_layers: action.payload.layers,
  },
  isPgLayerListFetching: false,
  isPgLayerListFetched: true,
});

const pgLayerListFailure = state => ({
  ...state,
  isPgLayerListFetching: false,
  isPgLayerListFetched: false,
});

const updateStyleListRequest = state => ({
  ...state,
  isStyleListUpdating: true,
});

const updateStyleListSuccess = (state, action) => ({
  ...state,
  district: {
    ...state.district,
    styles: action.payload,
  },
  isStyleListUpdating: false,
  isStyleListUpdated: true,
});

const updateStyleListFailure = state => ({
  ...state,
  isStyleListUpdating: false,
  isStyleListUpdated: false,
});

const deleteStyleRequest = state => ({
  ...state,
  isStyleDeleting: true,
});
const deleteStyleSuccess = (state, action) => ({
  ...state,
  district: {
    ...state.district,
    styles: action.payload.styles,
  },
  isStyleDeleting: false,
});
const deleteStyleFailure = state => ({
  ...state,
  isStyleDeleting: false,
});

const addStyleRequest = state => ({
  ...state,
  isAddingStyle: true,
});
const addStyleSuccess = (state, action) => ({
  ...state,
  district: {
    ...state.district,
    styles: action.payload.styles,
  },
  isAddingStyle: false,
});
const addStyleFailure = state => ({
  ...state,
  isAddingStyle: false,
});

const addStyleFromFileRequest = state => ({
  ...state,
  isAddingStyle: true,
});
const addStyleFromFileSuccess = (state, action) => ({
  ...state,
  district: {
    ...state.district,
    styles: action.payload.styles,
  },
  isAddingStyle: false,
});
const addStyleFromFileFailure = state => ({
  ...state,
  isAddingStyle: false,
});

const changeLayerStyleRequest = state => ({
  ...state,
  isLayerStyleChanging: true,
});
const changeLayerStyleSuccess = (state, action) => ({
  ...state,
  district: {
    ...state.district,
    layers: action.payload.layers,
  },
  isLayerStyleChanging: false,
});
const changeLayerStyleFailure = state => ({
  ...state,
  isLayerStyleChanging: false,
});

const publishLayerRequest = state => ({
  ...state,
  isPublishingLayer: true,
});
const publishLayerSuccess = state => ({
  ...state,
  isPublishingLayer: false,
});
const publishLayerFailure = state => ({
  ...state,
  isPublishingLayer: false,
});

const addExternalLayerRequest = state => ({
  ...state,
  isAddingExternal: true,
});
const addExternalLayerSuccess = (state, action) => ({
  ...state,
  district: {
    ...state.district,
    externalLayers: action.payload.externallayers,
  },
  isAddingExternal: false,
});
const addExternalLayerFailure = state => ({
  ...state,
  isAddingExternal: false,
});

const deleteExternalLayerRequest = state => ({
  ...state,
  isDeletingExternal: true,
});
const deleteExternalLayerSuccess = (state, action) => ({
  ...state,
  district: {
    ...state.district,
    externalLayers: action.payload.externallayers,
  },
  isDeletingExternal: false,
});
const deleteExternalLayerFailure = state => ({
  ...state,
  isDeletingExternal: false,
});

const addRoleRequest = state => ({
  ...state,
  isAddingRole: true,
});
const addRoleSuccess = (state, action) => ({
  ...state,
  district: {
    ...state.district,
    roles: action.payload.roles,
  },
  isAddingRole: false,
});
const addRoleFailure = state => ({
  ...state,
  isAddingRole: false,
});

const deleteRoleRequest = state => ({
  ...state,
  isDeletingRole: true,
});
const deleteRoleSuccess = (state, action) => ({
  ...state,
  district: {
    ...state.district,
    roles: action.payload.roles,
  },
  isDeletingRole: false,
});
const deleteRoleFailure = state => ({
  ...state,
  isDeletingRole: false,
});
// ADD ROLE LAYER
const addRoleLayerPermissionsRequest = state => ({
  ...state,
  isAddingRoleLayerPermission: true,
});
const addRoleLayerPermissionsSuccess = (state, action) => ({
  ...state,
  district: {
    ...state.district,
    roles: action.payload.roles,
  },
  isAddingRoleLayerPermission: false,
});
const addRoleLayerPermissionsFailure = state => ({
  ...state,
  isAddingRoleLayerPermission: false,
});
// DELETE ROLE LAYER
const deleteRoleLayerPermissionsRequest = state => ({
  ...state,
  isDeletingRoleLayerPermission: true,
});
const deleteRoleLayerPermissionsSuccess = (state, action) => ({
  ...state,
  district: {
    ...state.district,
    roles: action.payload.roles,
  },
  isDeletingRoleLayerPermission: false,
});
const deleteRoleLayerPermissionsFailure = state => ({
  ...state,
  isDeletingRoleLayerPermission: false,
});
// UPDATE ROLE LAYER
const updateRoleLayerPermissionsRequest = state => ({
  ...state,
  isUpdatingRoleLayerPermission: true,
});
const updateRoleLayerPermissionsSuccess = (state, action) => ({
  ...state,
  district: {
    ...state.district,
    roles: action.payload.roles,
  },
  isUpdatingRoleLayerPermission: false,
});
const updateRoleLayerPermissionsFailure = state => ({
  ...state,
  isUpdatingRoleLayerPermission: false,
});
// UPDATE ATTRS PERMISSIONS
const updateAttrsLayerPermissionsRequest = state => ({
  ...state,
  isUpdatingAttrsLayerPermission: true,
});
const updateAttrsLayerPermissionsSuccess = (state, action) => ({
  ...state,
  district: {
    ...state.district,
    roles: action.payload.roles,
  },
  isUpdatingAttrsLayerPermission: false,
});
const updateAttrsLayerPermissionsFailure = state => ({
  ...state,
  isUpdatingAttrsLayerPermission: false,
});
// UPDATE ROLE FEATURES
const updateRoleFeaturesRequest = state => ({
  ...state,
  isUpdatingRoleFeatures: true,
});
const updateRoleFeaturesSuccess = (state, action) => ({
  ...state,
  district: {
    ...state.district,
    roles: action.payload.roles,
  },
  isUpdatingRoleFeatures: false,
});
const updateRoleFeaturesFailure = state => ({
  ...state,
  isUpdatingRoleFeatures: false,
});
// ADD COMPOSITION
const addCompositionRequest = state => ({
  ...state,
  isAddingComposition: true,
});
const addCompositionSuccess = (state, action) => ({
  ...state,
  district: {
    ...state.district,
    compositions: action.payload.compositions,
  },
  isAddingComposition: false,
});
const addCompositionFailure = state => ({
  ...state,
  isAddingComposition: false,
});
// DELETE COMPOSITION
const deleteCompositionRequest = state => ({
  ...state,
  isDeletingComposition: true,
});
const deleteCompositionSuccess = (state, action) => ({
  ...state,
  district: {
    ...state.district,
    compositions: action.payload.compositions,
  },
  isDeletingComposition: false,
});
const deleteCompositionFailure = state => ({
  ...state,
  isDeletingComposition: false,
});

// DELETE COMPOSITION
const deleteGSLayerRequest = state => ({
  ...state,
  isDeletingGSLayer: true,
});
const deleteGSLayerSuccess = (state, action) => ({
  ...state,
  district: {
    ...state.district,
    layers: action.payload.layers,
  },
  isDeletingGSLayer: false,
});
const deleteGSLayerFailure = state => ({
  ...state,
  isDeletingGSLayer: false,
});

// CREATE NEW LAYER
const createLayerRequest = state => ({
  ...state,
  isCreatingNewlayer: true,
});
const createLayerSuccess = (state, action) => ({
  ...state,
  district: {
    ...state.district,
    pg_layers: action.payload,
  },
  isCreatingNewlayer: false,
});
const createLayerFailure = state => ({
  ...state,
  isCreatingNewlayer: false,
});

const sideDescriptionChange = (state, action) => ({
  ...state,
  sideDescription: {
    view: action.payload.view,
    data: action.payload.data,
    invest: action.payload.invest,
    contentType: action.payload.contentType,
  },
});

const letsDrawSomeProject = (state, action) => ({
  ...state,
  sideDescription: {
    ...state.sideDescription,
    invest: action.payload.invest,
  },
});

const choseParcel = (state, action) => ({
  ...state,
  chosenParcel: action.payload.data,
});

const gravesFetchingRequest = state => ({
  ...state,
  isDistrictFetching: true,
  isDistrictFetched: false,
});
const gravesFetchingSuccess = (state, action) => ({
  ...state,
  graves: {
    ...state.graves,
    features: action.payload.features,
  },
  isDistrictFetching: false,
  isDistrictFetched: true,
});
const gravesFetchingFailure = state => ({
  ...state,
  isDistrictFetching: false,
  isDistrictFetched: false,
});

const zarzadFetchingRequest = state => ({
  ...state,
  isZarzadFetching: true,
  isZarzadFetched: false,
});
const zarzadFetchingSuccess = (state, action) => ({
  ...state,
  zarzad: action.payload,
  isZarzadFetching: false,
  isZarzadFetched: true,
});
const zarzadFetchingFailure = state => ({
  ...state,
  isZarzadFetched: false,
  isZarzadFetching: false,
});

const graveyardFetchingRequest = state => ({
  ...state,
  isGraveyardFetching: true,
  isGraveyardFetched: false,
});
const graveyardFetchingSuccess = (state, action) => ({
  ...state,
  isGraveyardFetching: false,
  isGraveyardFetched: true,
  graveyard: {
    ...state.graveyard,
    features: action.payload.features,
  },
});
const graveyardFetchingFailure = state => ({
  ...state,
  isGraveyardFetching: false,
  isGraveyardFetched: false,
});

const sectorsFetchingRequest = state => ({
  ...state,
  isSectorsFetching: true,
  isSectorsFetched: false,
});
const sectorsFetchingSuccess = (state, action) => ({
  ...state,
  isSectorsFetching: false,
  isSectorsFetched: true,
  sectors: {
    ...state.sectors,
    features: action.payload.features,
  },
});
const chooseGrave = (state, action) => ({
  ...state,
  chosenGrave: action.payload,
});

const chooseGraveyard = (state, action) => ({
  ...state,
  chosenGraveyard: action.payload,
});

const sectorsFetchingFailure = state => ({
  ...state,
  isSectorsFetching: false,
  isSectorsFetched: false,
});

const changeAddressPolygon = (state, action) => ({
  ...state,
  addressPolygon: action.payload,
});

const deleteLayerFailure = state => ({
  ...state,
  isDeletingLayer: false,
});
const deleteLayerRequest = state => ({
  ...state,
  isDeletingLayer: true,
});
const deleteLayerSuccess = (state, action) => ({
  ...state,
  district: {
    ...state.district,
    pg_layers: _.filter(state.district.pg_layers, v => v !== action.payload),
  },
  isDeletingLayer: false,
});

export default function reducer(state = districtInitialState, action) {
  return ({
    [FETCH_DISTRICT_REQUEST]: districtRequest,
    [FETCH_DISTRICT_SUCCESS]: districtSuccess,
    [FETCH_DISTRICT_FAILURE]: districtFailure,
    [FETCH_ALL_DISTRICTS_REQUEST]: districtsRequest,
    [FETCH_ALL_DISTRICTS_SUCCESS]: districtsSuccess,
    [FETCH_ALL_DISTRICTS_FAILURE]: districtsFailure,
    [FETCH_ALL_ESERVICES_REQUEST]: sevicesRequest,
    [FETCH_ALL_ESERVICES_SUCCESS]: servicesSuccess,
    [FETCH_ALL_ESERVICES_FAILURE]: servicesFailure,
    [FETCH_DISTRICT_COMPOSITIONS_REQUEST]: fetchDistrictCompositionsRequest,
    [FETCH_DISTRICT_COMPOSITIONS_SUCCESS]: fetchDistrictCompositionsSuccess,
    [FETCH_DISTRICT_COMPOSITIONS_FAILURE]: fetchDistrictCompositionsFailure,
    [FETCH_DISTRICT_ROLES_REQUEST]: fetchDistrictrolesRequest,
    [FETCH_DISTRICT_ROLES_SUCCESS]: fetchDistrictrolesSuccess,
    [FETCH_DISTRICT_ROLES_FAILURE]: fetchDistrictrolesFailure,
    [FETCH_DISTRICT_FEATURES_REQUEST]: fetchDistrictFeaturesRequest,
    [FETCH_DISTRICT_FEATURES_SUCCESS]: fetchDistrictFeaturesSuccess,
    [FETCH_DISTRICT_FEATURES_FAILURE]: fetchDistrictFeaturesFailure,
    [FETCH_DISTRICT_LAYERS_REQUEST]: fetchDistrictLayersRequest,
    [FETCH_DISTRICT_LAYERS_SUCCESS]: fetchDistrictLayersSuccess,
    [FETCH_DISTRICT_LAYERS_FAILURE]: fetchDistrictLayersFailure,
    [FETCH_DISTRICT_EXTERNALLAYERS_REQUEST]: fetchDistrictExternalLayersRequest,
    [FETCH_DISTRICT_EXTERNALLAYERS_SUCCESS]: fetchDistrictExternalLayersSuccess,
    [FETCH_DISTRICT_EXTERNALLAYERS_FAILURE]: fetchDistrictExternalLayersFailure,
    [FETCH_DISTRICT_STYLES_REQUEST]: fetchDistrictStylesRequest,
    [FETCH_DISTRICT_STYLES_SUCCESS]: fetchDistrictStylesSuccess,
    [FETCH_DISTRICT_STYLES_FAILURE]: fetchDistrictStylesFailure,
    [FETCH_DISTRICT_PARCELS_REQUEST]: fetchDistrictParcelsRequest,
    [FETCH_DISTRICT_PARCELS_SUCCESS]: fetchDistrictParcelsSuccess,
    [FETCH_DISTRICT_PARCELS_FAILURE]: fetchDistrictParcelsFailure,
    [FETCH_PG_LAYER_DATA_REQUEST]: pgLayerDataRequest,
    [FETCH_PG_LAYER_DATA_SUCCESS]: pgLayerDataSuccess,
    [FETCH_PG_LAYER_DATA_FAILURE]: pgLayerDataFailure,
    [FETCH_PGLAYERLIST_REQUEST]: pgLayerListRequest,
    [FETCH_PGLAYERLIST_SUCCESS]: pgLayerListSuccess,
    [FETCH_PGLAYERLIST_FAILURE]: pgLayerListFailure,
    [FETCH_UPDATE_STYLE_LIST_REQUEST]: updateStyleListRequest,
    [FETCH_UPDATE_STYLE_LIST_SUCCESS]: updateStyleListSuccess,
    [FETCH_UPDATE_STYLE_LIST_FAILURE]: updateStyleListFailure,
    [DELETE_STYLE_REQUEST]: deleteStyleRequest,
    [DELETE_STYLE_SUCCESS]: deleteStyleSuccess,
    [DELETE_STYLE_FAILURE]: deleteStyleFailure,
    [ADD_STYLE_REQUEST]: addStyleRequest,
    [ADD_STYLE_SUCCESS]: addStyleSuccess,
    [ADD_STYLE_FAILURE]: addStyleFailure,
    [ADD_STYLE_FILE_REQUEST]: addStyleFromFileRequest,
    [ADD_STYLE_FILE_SUCCESS]: addStyleFromFileSuccess,
    [ADD_STYLE_FILE_FAILURE]: addStyleFromFileFailure,
    [CHANGE_LAYER_STYLE_REQUEST]: changeLayerStyleRequest,
    [CHANGE_LAYER_STYLE_SUCCESS]: changeLayerStyleSuccess,
    [CHANGE_LAYER_STYLE_FAILURE]: changeLayerStyleFailure,
    [PUBLISH_LAYER_REQUEST]: publishLayerRequest,
    [PUBLISH_LAYER_SUCCESS]: publishLayerSuccess,
    [PUBLISH_LAYER_FAILURE]: publishLayerFailure,
    [ADD_EXTERNAL_LAYER_REQUEST]: addExternalLayerRequest,
    [ADD_EXTERNAL_LAYER_SUCCESS]: addExternalLayerSuccess,
    [ADD_EXTERNAL_LAYER_FAILURE]: addExternalLayerFailure,
    [DELETE_EXTERNAL_LAYER_REQUEST]: deleteExternalLayerRequest,
    [DELETE_EXTERNAL_LAYER_SUCCESS]: deleteExternalLayerSuccess,
    [DELETE_EXTERNAL_LAYER_FAILURE]: deleteExternalLayerFailure,
    [ADD_ROLE_REQUEST]: addRoleRequest,
    [ADD_ROLE_SUCCESS]: addRoleSuccess,
    [ADD_ROLE_FAILURE]: addRoleFailure,
    [DELETE_ROLE_REQUEST]: deleteRoleRequest,
    [DELETE_ROLE_SUCCESS]: deleteRoleSuccess,
    [DELETE_ROLE_FAILURE]: deleteRoleFailure,
    [ADD_ROLE_LAYER_PERMISSIONS_REQUEST]: addRoleLayerPermissionsRequest,
    [ADD_ROLE_LAYER_PERMISSIONS_SUCCESS]: addRoleLayerPermissionsSuccess,
    [ADD_ROLE_LAYER_PERMISSIONS_FAILURE]: addRoleLayerPermissionsFailure,
    [DELETE_ROLE_LAYER_PERMISSIONS_REQUEST]: deleteRoleLayerPermissionsRequest,
    [DELETE_ROLE_LAYER_PERMISSIONS_SUCCESS]: deleteRoleLayerPermissionsSuccess,
    [DELETE_ROLE_LAYER_PERMISSIONS_FAILURE]: deleteRoleLayerPermissionsFailure,
    [UPDATE_ROLE_LAYER_PERMISSIONS_REQUEST]: updateRoleLayerPermissionsRequest,
    [UPDATE_ROLE_LAYER_PERMISSIONS_SUCCESS]: updateRoleLayerPermissionsSuccess,
    [UPDATE_ROLE_LAYER_PERMISSIONS_FAILURE]: updateRoleLayerPermissionsFailure,
    [UPDATE_ROLE_ATTRS_PERMISSIONS_REQUEST]: updateAttrsLayerPermissionsRequest,
    [UPDATE_ROLE_ATTRS_PERMISSIONS_SUCCESS]: updateAttrsLayerPermissionsSuccess,
    [UPDATE_ROLE_ATTRS_PERMISSIONS_FAILURE]: updateAttrsLayerPermissionsFailure,
    [UPDATE_ROLE_FEATURES_REQUEST]: updateRoleFeaturesRequest,
    [UPDATE_ROLE_FEATURES_SUCCESS]: updateRoleFeaturesSuccess,
    [UPDATE_ROLE_FEATURES_FAILURE]: updateRoleFeaturesFailure,
    [ADD_COMOPSITION_REQUEST]: addCompositionRequest,
    [ADD_COMOPSITION_SUCCESS]: addCompositionSuccess,
    [ADD_COMOPSITION_FAILURE]: addCompositionFailure,
    [DELETE_COMOPSITION_REQUEST]: deleteCompositionRequest,
    [DELETE_COMOPSITION_SUCCESS]: deleteCompositionSuccess,
    [DELETE_COMOPSITION_FAILURE]: deleteCompositionFailure,
    [DELETE_GES_LAYER_REQUEST]: deleteGSLayerRequest,
    [DELETE_GES_LAYER_SUCCESS]: deleteGSLayerSuccess,
    [DELETE_GES_LAYER_FAILURE]: deleteGSLayerFailure,
    [CREATE_NEW_LAYER_REQUEST]: createLayerRequest,
    [CREATE_NEW_LAYER_SUCCESS]: createLayerSuccess,
    [CREATE_NEW_LAYER_FAILURE]: createLayerFailure,
    [SIDEDESCRIPTION_VIEW]: sideDescriptionChange,
    [SIDEDESCRIPTION_VIEW_PROJECT]: letsDrawSomeProject,
    [CHOSEN_PARCEL]: choseParcel,
    [FETCH_GRAVES_REQUEST]: gravesFetchingRequest,
    [FETCH_GRAVES_SUCCESS]: gravesFetchingSuccess,
    [FETCH_GRAVES_FAILURE]: gravesFetchingFailure,
    [FETCH_ZARZAD_REQUEST]: zarzadFetchingRequest,
    [FETCH_ZARZAD_SUCCESS]: zarzadFetchingSuccess,
    [FETCH_ZARZAD_FAILURE]: zarzadFetchingFailure,
    [FETCH_GRAVEYARD_REQUEST]: graveyardFetchingRequest,
    [FETCH_GRAVEYARD_SUCCESS]: graveyardFetchingSuccess,
    [FETCH_GRAVEYARD_FAILURE]: graveyardFetchingFailure,
    [FETCH_SECTORS_REQUEST]: sectorsFetchingRequest,
    [FETCH_SECTORS_SUCCESS]: sectorsFetchingSuccess,
    [FETCH_SECTORS_FAILURE]: sectorsFetchingFailure,
    [CHOOSE_GRAVE]: chooseGrave,
    [CHOOSE_GRAVEYARD]: chooseGraveyard,
    [DELETE_LAYER_FAILURE]: deleteLayerFailure,
    [DELETE_LAYER_REQUEST]: deleteLayerRequest,
    [DELETE_LAYER_SUCCESS]: deleteLayerSuccess,
    [ADDRESS_POLYGON]: changeAddressPolygon,
    [FETCH_ALLDISTRICTSERVICES_REQUEST]: districtServicesRequest,
    [FETCH_ALLDISTRICTSERVICES_SUCCESS]: districtServicesSuccess,
    [FETCH_ALLDISTRICTSERVICES_FAILURE]: districtServicesFailure,
  }[action.type] || (s => s))(state, action);
}



// WEBPACK FOOTER //
// src/reducers/district.js